import { render, staticRenderFns } from "./EmergencyEmail.vue?vue&type=template&id=66718494"
import script from "./EmergencyEmail.vue?vue&type=script&lang=js"
export * from "./EmergencyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports